var App = App || {};

App.HeroSlides = (function() {
  'use strict';

  var initialize = function() {
    _initSlides();
  };

  var _initSlides = function() {
    $('.page-hero-slides').slick({
      appendDots: $('.hero-slider-dots-container'),
      arrows: false,
      autoplay: true,
      dots: true,
      fade: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 1000
    });
  };

  return {
    initialize: initialize
  };
}());
